<template>
  <div :class="$style['task-order']">
    <h1>北京市科学技术研究院分析测试研究所</h1>
    <h2>(北京市理化分析测试中心)</h2>
    <h1>检测任务下达单</h1>
    <table cellspacing="0" border="1">
      <tr>
        <td>样品名称</td>
        <td colspan="3">{{ data.sampleName }}</td>
      </tr>
      <tr>
        <td>样品编号</td>
        <td colspan="3">{{ data.sampleCode }}</td>
      </tr>
      <tr>
        <td>样品存放条件</td>
        <td colspan="3">{{ data.storage }}</td>
      </tr>
      <tr>
        <td>检测依据</td>
        <td colspan="3">
          <template
            v-if="data.examinationItemBasis && data.examinationItemBasis.length"
          >
            <div
              v-for="(item, index) in data.examinationItemBasis"
              :key="index"
            >
              {{ item }}
            </div>
          </template>
        </td>
      </tr>
      <tr>
        <td>检测项目</td>
        <td colspan="3">
          <template
            v-if="data.examinationItems && data.examinationItems.length"
          >
					{{data.examination_items}}
            <!-- <div v-for="(item, index) in data.examinationItems" :key="index">
              {{ item }}
            </div> -->
          </template>
          <!-- {{ data.examination_items }} -->
        </td>
      </tr>
      <tr>
        <td>任务下达日期</td>
        <td class="foure-of-two">{{ data.issued_date }}</td>
        <td>任务完成日期</td>
        <td class="foure-of-two">{{ data.completion_date }}</td>
      </tr>
      <tr>
        <td>任务下达人</td>
        <td><img v-if="issuedUser" :src="issuedUser"/></td>
        <td>检测人员</td>
        <td><img v-if="inspectorUser" :src="inspectorUser"/></td>
      </tr>
      <tr>
        <td>领样人</td>
        <td>
					<!-- <img v-if="receivedSampleUser" :src="receivedSampleUser"/> -->
        </td>
        <td>日期</td>
        <td></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    loaded: Boolean,
		loadErr: Boolean,
		reportDataId:String
  },
  watch: {
    loaded(val) {
      if (val) {
        this.checkLoad();
      }
    },
    loadErr(val) {
      if (val) {
        this.checkLoad();
      }
    },
	},
	computed:{
		privateResourcesUrl(){
			return this.$privateResourcesUrl
		},
		issuedUser(){
			return this.data.issuedUser?this.$getPrivateResourceUrl(this.data.issuedUser,this.reportDataId,'.png'):''
		},
		inspectorUser(){
			return this.data.inspectorUser?this.$getPrivateResourceUrl(this.data.inspectorUser,this.reportDataId,'.png'):''
		},
		receivedSampleUser(){
			return this.data.receivedSampleUser?this.$getPrivateResourceUrl(this.data.receivedSampleUser,this.reportDataId,'.png'):''
		}
	},
  methods: {
    checkLoad() {
      if (this.loaded) {
        this.loadedPage = true;
        confirm("加载完成");
      }
      if (this.loadedErr) {
        this.loadedPage = true;
        confirm("加载失败");
      }
    },
  },
};
</script>
<style module lang="less">
.task-order {
  // padding-top: 30px;
  padding: 30px 15px 15px;
  h1,
  h2 {
    margin-block-start: 0.3em;
    margin-block-end: 0.3em;
	}
	h1{
		font-size: 1.6em
	}
	h2{
		font-size: 1.2em
	}
  table {
		width: 100%;
		img{
			height: 50px;
		}
    tr {
      :first-child {
        // width: 25%;
      }
      td {
        &:first-of-type {
          width: 25%;
        }
        line-height: 30px;
      }
    }
    :global {
      .foure-of-two {
        width: 25%;
      }
    }
  }
}
</style>
